import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { EtfCompositionItem } from "../types";
import { loadEtfComnposition } from "../thunks/getEtfCompositionThunk";

export const useDisplayEtfComposition = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    EtfCompositionItem | undefined
  >((store) => store.data.reports.securityStatistics.displayEtfComposition);

  const displayedEtfComposition =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadEtfComnposition( symbol));
    }
  }, [dispatch, symbol]);

  return displayedEtfComposition;
};